import axiosClient from "../axios/axiosClient";

export function getPublications() {
  return axiosClient.get("/publications");
}

export function getPublication(publicationId) {
  return axiosClient.get(`/publications/${publicationId}`);
}

export function createPublication(data) {
  return axiosClient.post("/publications", data);
}

export const updatePublication = (publicationId, data) => {
  return axiosClient.put(`/publications/${publicationId}`, data);
};

export function deletePublication(publicationId) {
  return axiosClient.delete(`/publications/${publicationId}`);
}
